import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Checkout label inside a Plan Sheet; tokens {price} {interval} {tier}.
export default class LabelTemplate extends BaseOption {
  static userInterfaceComponent = {
    label: "Label Template",
    component: inspectorTools.SIMPLE_INPUT,
  };

  static defaultValue = "Continue · {price}/{interval}";
}
